import type {
  FormattedMemberAttributes,
  FormattedMemberGroups,
  FormattedMemberProfile,
  FormattedMembersResponse,
  MemberColumns,
  MembersFeatureFlag
} from '@library/types/members';
import type { TableColumn } from '@library/types/utils';

export const MEMBERS_HEADER: Array<TableColumn<MemberColumns>> = [
  {
    column: 'member',
    essential: true,
    label: 'Member',
    sortEnabled: false,
    width: 'basis-96'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: false
  },
  {
    column: 'joined_on',
    essential: true,
    label: 'Joined on',
    sortEnabled: false
  },
  {
    column: 'date_of_birth',
    essential: true,
    label: 'Date of birth',
    sortEnabled: false
  }
];

export const EMPTY_MEMBERS_RESPONSE: FormattedMembersResponse = {
  currentPage: 0,
  members: [],
  totalPages: 0
};

export const DEFAULT_MEMBER_DETAILS: FormattedMemberAttributes = {
  createdAt: '',
  email: '',
  firstName: '',
  fullName: '',
  lastName: ''
};

export const DEFAULT_MEMBER_GROUPS: FormattedMemberGroups = [
  {
    id: undefined,
    name: 'None'
  }
];

export const DEFAULT_MEMBER_FEATURE_FLAGS: MembersFeatureFlag = {
  isRulesetRevampActive: false
};

export const DEFAULT_PROFILE_DETAILS: FormattedMemberProfile = {
  username: 'N/A',
  visibility: ['N/A'],
  verified: false
};

export const FETCH_MEMBERS_PER_PAGE_COUNT = 25;
export const FETCH_PROMOTIONS_PER_PAGE_COUNT = 50;
export const FETCH_REFERRALS_PER_PAGE_COUNT = 50;
export const FETCH_TRANSACTIONS_PER_PAGE_COUNT = 50;

export const DATE_FORMAT = 'MMMM d, yyyy';
export const DATE_TIME_FORMAT = "MMMM d, yyyy 'at' h:mm:ss a 'ET'";
export const TIME_FORMAT = "h:mm:ss a 'ET'";
export const DOB_DATE_FORMAT = 'yyyy-MM-dd';
